<template>
    <div>
        <span>{{ cellValue }}</span>
        <a class="view_anchor" v-if="task.length !== 0" @click.stop="buttonClicked">View</a>
        <vs-popup fullscreen class="holamundo"  :title="`${this.cellValue}`" :active.sync="popupActivo">
            <vs-table :data="task">
                <template slot="thead">
                  <vs-th>
                        Sr. No
                    </vs-th>
                    <vs-th>
                        Task Name
                    </vs-th>
                    <vs-th>
                        Task Details
                    </vs-th>
                    <vs-th>
                        Deadline
                    </vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                      <vs-td :data="data[indextr].id">
                            {{indextr+1}}
                        </vs-td>
                        <vs-td :data="data[indextr].name">
                            {{data[indextr].name}}
                        </vs-td>
                        <vs-td :data="data[indextr].details">
                            {{data[indextr].details}}
                        </vs-td>
                        <vs-td :data="data[indextr].due_date">
                            {{data[indextr].due_date}}
                        </vs-td>
                    </vs-tr>
                    
                </template>
            </vs-table>
        </vs-popup>
    </div>
</template>

<script>
import { taskShow } from '@/api/task-project.js'
export default {
  name: 'ReferenceAction',
  data () {
    return {
      cellValue: null,
      task: [],
      popupActivo: false
    }
  },
  beforeMount () {
    // this.params contains the cell & row information and is made available to this component at creation time
    // see ICellRendererParams below for more details
    this.cellValue = this.getValueToDisplay(this.params)
  },
  methods: {
    // gets called whenever the user gets the cell to refresh
    refresh (params) {
      // set value into cell again
      this.cellValue = this.getValueToDisplay(params)
    },

    buttonClicked () {
      taskShow(localStorage.getItem('customer_id'), this.params.data.id)
        .then((res) => {
          
          this.task = res.data.data.task.subtask
        })
        .catch((e) => {
          
        })
      this.popupActivo = true
    },

    getValueToDisplay (params) {
      return params.valueFormatted ? params.valueFormatted : params.value
    }
  }
}
</script>

<style>
    .view_anchor {
        display: flex;
        width: 100%;
        height: 35px;
        align-items: center;
        cursor: pointer;
    }
</style>